/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createExchangeRate = /* GraphQL */ `
  mutation CreateExchangeRate(
    $input: CreateExchangeRateInput!
    $condition: ModelExchangeRateConditionInput
  ) {
    createExchangeRate(input: $input, condition: $condition) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExchangeRate = /* GraphQL */ `
  mutation UpdateExchangeRate(
    $input: UpdateExchangeRateInput!
    $condition: ModelExchangeRateConditionInput
  ) {
    updateExchangeRate(input: $input, condition: $condition) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExchangeRate = /* GraphQL */ `
  mutation DeleteExchangeRate(
    $input: DeleteExchangeRateInput!
    $condition: ModelExchangeRateConditionInput
  ) {
    deleteExchangeRate(input: $input, condition: $condition) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCourse = /* GraphQL */ `
  mutation CreateCourse(
    $input: CreateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    createCourse(input: $input, condition: $condition) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCourse = /* GraphQL */ `
  mutation UpdateCourse(
    $input: UpdateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    updateCourse(input: $input, condition: $condition) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCourse = /* GraphQL */ `
  mutation DeleteCourse(
    $input: DeleteCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    deleteCourse(input: $input, condition: $condition) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLesson = /* GraphQL */ `
  mutation CreateLesson(
    $input: CreateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    createLesson(input: $input, condition: $condition) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLesson = /* GraphQL */ `
  mutation UpdateLesson(
    $input: UpdateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    updateLesson(input: $input, condition: $condition) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLesson = /* GraphQL */ `
  mutation DeleteLesson(
    $input: DeleteLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    deleteLesson(input: $input, condition: $condition) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBook = /* GraphQL */ `
  mutation CreateBook(
    $input: CreateBookInput!
    $condition: ModelBookConditionInput
  ) {
    createBook(input: $input, condition: $condition) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBook = /* GraphQL */ `
  mutation UpdateBook(
    $input: UpdateBookInput!
    $condition: ModelBookConditionInput
  ) {
    updateBook(input: $input, condition: $condition) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBook = /* GraphQL */ `
  mutation DeleteBook(
    $input: DeleteBookInput!
    $condition: ModelBookConditionInput
  ) {
    deleteBook(input: $input, condition: $condition) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBookOrder = /* GraphQL */ `
  mutation UpdateBookOrder(
    $input: UpdateBookOrderInput!
    $condition: ModelBookOrderConditionInput
  ) {
    updateBookOrder(input: $input, condition: $condition) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBookOrder = /* GraphQL */ `
  mutation DeleteBookOrder(
    $input: DeleteBookOrderInput!
    $condition: ModelBookOrderConditionInput
  ) {
    deleteBookOrder(input: $input, condition: $condition) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserNote = /* GraphQL */ `
  mutation CreateUserNote(
    $input: CreateUserNoteInput!
    $condition: ModelUserNoteConditionInput
  ) {
    createUserNote(input: $input, condition: $condition) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserNote = /* GraphQL */ `
  mutation UpdateUserNote(
    $input: UpdateUserNoteInput!
    $condition: ModelUserNoteConditionInput
  ) {
    updateUserNote(input: $input, condition: $condition) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserNote = /* GraphQL */ `
  mutation DeleteUserNote(
    $input: DeleteUserNoteInput!
    $condition: ModelUserNoteConditionInput
  ) {
    deleteUserNote(input: $input, condition: $condition) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEnrollment = /* GraphQL */ `
  mutation UpdateEnrollment(
    $input: UpdateEnrollmentInput!
    $condition: ModelEnrollmentConditionInput
  ) {
    updateEnrollment(input: $input, condition: $condition) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEnrollment = /* GraphQL */ `
  mutation DeleteEnrollment(
    $input: DeleteEnrollmentInput!
    $condition: ModelEnrollmentConditionInput
  ) {
    deleteEnrollment(input: $input, condition: $condition) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDocumentRequest = /* GraphQL */ `
  mutation UpdateDocumentRequest(
    $input: UpdateDocumentRequestInput!
    $condition: ModelDocumentRequestConditionInput
  ) {
    updateDocumentRequest(input: $input, condition: $condition) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDocumentRequest = /* GraphQL */ `
  mutation DeleteDocumentRequest(
    $input: DeleteDocumentRequestInput!
    $condition: ModelDocumentRequestConditionInput
  ) {
    deleteDocumentRequest(input: $input, condition: $condition) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBannerAd = /* GraphQL */ `
  mutation CreateBannerAd(
    $input: CreateBannerAdInput!
    $condition: ModelBannerAdConditionInput
  ) {
    createBannerAd(input: $input, condition: $condition) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBannerAd = /* GraphQL */ `
  mutation UpdateBannerAd(
    $input: UpdateBannerAdInput!
    $condition: ModelBannerAdConditionInput
  ) {
    updateBannerAd(input: $input, condition: $condition) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBannerAd = /* GraphQL */ `
  mutation DeleteBannerAd(
    $input: DeleteBannerAdInput!
    $condition: ModelBannerAdConditionInput
  ) {
    deleteBannerAd(input: $input, condition: $condition) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBookOrder = /* GraphQL */ `
  mutation CreateBookOrder(
    $input: CreateBookOrderInput!
    $condition: ModelBookOrderConditionInput
  ) {
    createBookOrder(input: $input, condition: $condition) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEnrollment = /* GraphQL */ `
  mutation CreateEnrollment(
    $input: CreateEnrollmentInput!
    $condition: ModelEnrollmentConditionInput
  ) {
    createEnrollment(input: $input, condition: $condition) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDocumentRequest = /* GraphQL */ `
  mutation CreateDocumentRequest(
    $input: CreateDocumentRequestInput!
    $condition: ModelDocumentRequestConditionInput
  ) {
    createDocumentRequest(input: $input, condition: $condition) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
